// extracted by mini-css-extract-plugin
module.exports = {"hotspotComponentWrapper":"to","slider-wrapper":"tp"};